import React, { ReactNode } from 'react';

import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Toggle from '@amzn/meridian/toggle';

import { isUndefined } from 'lodash';

interface IContractTermSection {
    title: string;
    subTitle?: string;
    isToggled?: boolean;
    handleToggle?: () => void;
    children?: ReactNode;
}

export const ContractTermSection: React.FC<IContractTermSection> = (props: IContractTermSection) => (
    <Box type="outline" spacingInset="400">
        <Column>
            <Column spacing="300">
                <Row alignmentHorizontal="justify">
                    <Text type="h400">{props.title}</Text>
                    {[props.isToggled, props.handleToggle].every((prop) => !isUndefined(prop)) && (
                        <Toggle checked={props.isToggled} onChange={props.handleToggle} />
                    )}
                </Row>
                {!isUndefined(props.subTitle) && (
                    <Text type="b200" color="secondary">
                        {props.subTitle}
                    </Text>
                )}
            </Column>
            {props.children}
        </Column>
    </Box>
);
